import React from "react"
import { ImageToutBlock, FeatureYouTube } from "containers"

const ToutBlock = (props) => {
  let newComponent = () => { }
  if (props.youTubeId) {
    newComponent = () => (
      <FeatureYouTube
        outline={this.props.outline}
        CMSGroupGTM={this.props.gtm}
        videoSrc={props.youTubeId}
        {...props} />
    )
  } else {
    newComponent = () => (
      <ImageToutBlock CMSGroupGTM={this.props.gtm} outline={this.props.outline} {...props} />
    )
  }
  return newComponent
}

export default ToutBlock



// WEBPACK FOOTER //
// ./src/blocks/tout-block/index.jsx